import { CmsImage } from '@zoopla/cms/image';
import {
    containerStyle,
    contentStyle,
    styledPStyle,
} from './CampaignCta.styles.css';
import { PageSubtitleShort } from '@zoopla-eng/zds/headings';
import { Box } from '@zoopla-eng/zds/box';
import { fontGroups } from '@zoopla-eng/zds/themes';

type Props = {
    className?: string;
    image: string;
    title: string;
    body: string;
    children?: React.ReactNode;
};

export const CampaignCta = ({
    className,
    image,
    title,
    body,
    children,
}: Props) => {
    return (
        <div className={`${containerStyle} ${className}`}>
            <CmsImage src={image} alt="" special />
            <div className={contentStyle}>
                <Box pb="S200">
                    <PageSubtitleShort>{title}</PageSubtitleShort>
                </Box>
                <p className={`${styledPStyle} ${fontGroups.whisk}`}>{body}</p>
                {children}
            </div>
        </div>
    );
};
